/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Link } from 'react-router-dom';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// reactstrap components
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
} from 'reactstrap';

function TimelineHeader({ name, parentName, link }) {
  return (
    <>
      <div className="header header-dark bg-gradient-purple pb-6 content__title content__title--calendar">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                <Breadcrumb
                  className="d-none d-md-inline-block ml-md-2"
                  listClassName="breadcrumb-links"
                >
                  <BreadcrumbItem>
                    {link ? (
                      <Link to={link}>
                        <i className="fas fa-home mr-2 text-white" />
                        {parentName}
                      </Link>
                    ) : (
                      <span className="text-white">
                        <i className="fas fa-home mr-2 text-white" />
                        {parentName}
                      </span>
                    )}
                  </BreadcrumbItem>
                  <BreadcrumbItem
                    aria-current="page"
                    className="active text-white font-weight-400"
                  >
                    {name}
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default TimelineHeader;
